import { Base2Presenter } from "core/presenter";
import { CategoryRepository } from "core/repository";

export default class ProductFormGeneralInfoPresenter extends Base2Presenter {
  initialState() {
    return {
      categorySearchOptions: {
        repository: CategoryRepository,
        order: [{ field: "name", direction: "ASC" }],
        pagination: { page: 1, perPage: 25 },
        filter: filter => this.getFilter(filter)
      },
      newVariations: false
    };
  }

  onChangeProps() {
    this.checkNewVariationsOptions();
  }

  getFilter(value) {
    return [
      { field: "name", operation: "LIKE", value },
      { field: "deleted", operation: "EQ", value: "false" }
    ];
  }

  onSelectCategory(category) {
    const { product } = this.props;
    product.category = category;
    product.category_uuid = product.category.uuid;
  }

  onNewVariationsOptions() {
    this.enqueue({ newVariations: true });
  }

  checkNewVariationsOptions() {
    if (!this.props.selectedVariations.length) {
      this.enqueue({ newVariations: false });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/product/form/general-info/general-info.presenter.js